module.exports = __webpack_public_path__ + "3851cb3e5933c9625e99f10fd888d499.svg";